module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_5.f44aa78a.pdf";